import { render } from "./App.vue?vue&type=template&id=bcdc8654&ts=true"
import script from "./script.ts?vue&type=script&lang=ts"
export * from "./script.ts?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/viktoriia/mood/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__